// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3WClB","container":"styles_container__3OR2Z","title":"styles_title__tPTS2","wrapper":"styles_wrapper__2WKhX","answer":"styles_answer__3YmMc"};